import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

// API to update the mask/unmask status
export const userDataMaskUnmaskApi = createAsyncThunk(
    'userData/maskingUnmasking',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.adminAction(`data_mask_unmask/`), data)
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

// API to fetch the current mask/unmask status
export const fetchUserMaskStatusApi = createAsyncThunk(
    'userData/fetchMaskStatus',
    async (_, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.adminAction(`data_mask_unmask/`))
            // console.log('===>>>',JSON.stringify(response,undefined,4));
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const userDataMaskUnmaskSlice = createSlice({
    name: 'userData/maskingUnmasking',
    initialState: { 
        result: {}, 
        loading: false, 
        error: null, 
        message: "", 
        isDataMasked: false 
    },
    extraReducers: (builder) => {
        // Reducers for updating mask/unmask status
        builder.addCase(userDataMaskUnmaskApi.pending, (state) => {
            state.loading = true
        })
        builder.addCase(userDataMaskUnmaskApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(userDataMaskUnmaskApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })

        // Reducers for fetching mask/unmask status
        builder.addCase(fetchUserMaskStatusApi.pending, (state) => {
            state.loading = true
        })
        builder.addCase(fetchUserMaskStatusApi.fulfilled, (state, action) => {
            // console.log('ction?.payload?===>>>',JSON.stringify(action?.payload,undefined,4));
            state.loading = false
            state.isDataMasked = action?.payload?.result?.is_data_masked
            state.message = action?.payload?.message
        })
        builder.addCase(fetchUserMaskStatusApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const userDataMaskUnmaskReducer = userDataMaskUnmaskSlice.reducer